module.exports = __webpack_public_path__ + "media/images/help/image-face-8e65607a4591e158729ac2337f1d4609.jpg";